import {
    DateTokenRegex,
    dateTokens,
    defaultDateFormat,
    IDate,
    IDateFormat,
    IDateFormatOptions,
    IDateMessageFormat,
    IDateToken
} from './DateFormatterConstants';

export interface IDateFormatter {
    locale: string;
}

export class DateFormatter {
    private locale: string;

    constructor(config: IDateFormatter) {
        this.locale = config.locale;
    }
    private createDate = (dateString: string) => {
        const parsedDateRegex = /(?<year>\d{2})(?<month>\d{2})(?<day>\d{2})/;
        const { groups = {} } = parsedDateRegex.exec(dateString) || {};

        const { year, month, day } = groups;
        const currentYear = new Date().getFullYear().toString();
        const fullYear = currentYear.replace(/(\d{2})(\d{2})/, `$1${year}`);
        const correctMonth = +month - 1;
        const date = new Date(+fullYear, correctMonth, +day);

        return date;
    };

    private byLocale = ({ locale, formats, date }: IDateFormatOptions) =>
        new Intl.DateTimeFormat(locale, formats).format(date);

    private isValidDateToken = (token: IDateToken) => DateTokenRegex.test(token);

    private getFormattedDate = ({ locale, dateFormat, date }: IDateFormat) => {
        const tokens = dateFormat.split(/[\/\.\- ]+/).filter(this.isValidDateToken);

        return tokens.reduce((dateTemplate: string, token: IDateToken) => {
            const dateFormatByLocale = this.byLocale({ locale, formats: dateTokens[token], date });

            return dateTemplate.replace(token, dateFormatByLocale);
        }, dateFormat);
    };

    private formatDateFromString = ({ date, dateFormat }: IDate): string => {
        const { locale } = this;
        const dateTemplate = dateFormat || defaultDateFormat;

        const formattedDate = this.getFormattedDate({
            locale,
            dateFormat: dateTemplate,
            date: this.createDate(date)
        });

        return formattedDate;
    };

    public formatDateWithPlaceholder = (dateFormatConfig: IDateMessageFormat) => {
        const { date, dateFormat, message, placeholderRegex } = dateFormatConfig;

        const formattedDate = this.formatDateFromString({ date, dateFormat });

        return message.replace(placeholderRegex, formattedDate);
    };
}
